import React from "react";
import { ArrowRight, HardHat } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSrdStandard() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll();
  return <section data-section-id="18990" id="recover-the-revenue-protect-the-legacy" className="dark relative min-h-[90vh] w-full overflow-hidden bg-background text-foreground lg:grid lg:grid-cols-2" style={{
    backgroundColor: 'var(--background)',
    color: 'var(--foreground)'
  }}>
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(var(--foreground) 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} />
      <div className="absolute inset-0 h-full w-full lg:relative lg:col-start-2 lg:inset-auto">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606688/img/substation_poster.png">
          <source src="/videos/substation_loop.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606688/img/substation_fallback.png" alt="High-end industrial mechanical room with blueprint overlays" className="h-full w-full object-cover" />
        </video>
        {}
        <div className="bg-background/80 absolute inset-0 lg:hidden" />
        {}
        <div className="from-background/50 to-transparent absolute inset-0 hidden bg-gradient-to-r lg:block" />
      </div>

      {}
      <div className="relative z-10 flex flex-col justify-center px-6 py-20 lg:col-start-1 lg:px-16 lg:py-0 xl:px-24">
        {}
        <div className="text-primary/10 font-mono absolute -top-10 -left-4 -z-10 select-none text-[12rem] font-bold leading-none tracking-tighter lg:-left-12 lg:top-1/4 lg:text-[20rem]" aria-hidden="true">
          01
        </div>

        <div ref={contentRef} className={`transition-all duration-1000 ease-out ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="font-serif text-5xl font-black leading-[0.9] tracking-tighter text-foreground sm:text-6xl md:text-7xl lg:text-8xl">
            RECOVER THE <br />
            <span className="text-primary">REVENUE.</span> <br />
            PROTECT THE <br />
            <span className="text-muted-foreground">LEGACY.</span>
          </h1>

          <p className="text-muted-foreground font-sans mt-8 max-w-lg text-lg font-medium md:text-xl">
            Exergy Ops is the invisible infrastructure that captures every missed lead 
            and injects it into your CRM with precision engineering.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-base font-bold uppercase tracking-widest shadow-lg shadow-primary/20">
              <Link to="/OperationalAuditPage">
                Begin Operational Audit
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="border-primary/30 text-foreground hover:bg-primary/10 hover:text-primary h-14 px-8 text-base font-bold uppercase tracking-widest backdrop-blur-sm">
              <Link to="/TheEnginePage">
                <HardHat className="mr-2 h-5 w-5" />
                The Engine
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}